import React from 'react';
import {
    createStyles,
    Text,
    Avatar,
    Group,
    TypographyStylesProvider,
    Paper,
    Textarea,
    Button,
    Card
} from '@mantine/core';

const useStyles = createStyles((theme) => ({
    comment: {
        padding: `${theme.spacing.lg}px ${theme.spacing.xl}px`,
        //width: "inherit"
    },
    defPadding: {
        padding: "8px"
    },
    commentBtn: {
        marginLeft: "4%",
        marginBottom: "3%",
        
    },
    body: {
        paddingLeft: 54,
        paddingTop: theme.spacing.sm,
        fontSize: theme.fontSizes.sm,
    },
    commentInputArea: {
        width: "95%",
        margin: "0 auto"
    },

    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
}));


export function CommentCreationCard() {
    const { classes } = useStyles();
    return (
        <Card withBorder radius="md" className={classes.comment}>
            <Card.Section className={classes.defPadding}>
                <Textarea
                    className={classes.commentInputArea}
                    placeholder={"Post A comment"}
                />
            </Card.Section>
            <br/>
            <Card.Section>
                <Button className={classes.commentBtn}>
                    Comment
                </Button>
            </Card.Section>
        </Card>
    );
}
